import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import { Toaster } from "sonner";
import { AuthModal } from "@/components/auth/AuthModal";
import { PaywallModal } from "@/components/billing/PaywallModal";
import { StructuredData } from "@/components/seo/StructuredData";
import { ConsentBanner } from "@/components/ui/ConsentBanner";
import { AuthProvider, ThemeProvider, AnalyticsProvider, QueryProvider } from "@/app/providers";

function LoadingFallback() {
  return (
    <div className="flex h-full w-full items-center justify-center p-6">
      <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
    </div>
  );
}

export function RootLayout() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AuthProvider>
          <StructuredData />
          <AnalyticsProvider />
          <AuthModal />
          <PaywallModal />
          <ConsentBanner />
          <Toaster position="top-center" theme="dark" richColors closeButton />
          <Suspense fallback={<LoadingFallback />}>
            <Outlet />
          </Suspense>
        </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
